module.exports = __webpack_public_path__ + "static/media/roboto-mono-v5-latin-700.f61e5a8d.woff";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/roboto-mono/roboto-mono-v5-latin-700.woff
// module id = 483
// module chunks = 0